"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PasswordApproved1: ['password-approved-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.956,14h8.609a.978.978,0,0,0,.5-.153,7.7,7.7,0,0,1,.472-.712A.872.872,0,0,0,11.565,13a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5l-.038-6a.5.5,0,0,1,.5-.5H21.5a.5.5,0,0,1,.5.5v4a1,1,0,0,0,2,0V5a1.981,1.981,0,0,0-1.956-2H1.956A1.981,1.981,0,0,0,0,5v7A1.981,1.981,0,0,0,1.956,14Z', 'M7.972,6.992a.751.751,0,0,0-1.038-.216l-.125.082a.25.25,0,0,1-.387-.209V6.5a.75.75,0,0,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,0,0-.832,1.248L4,8.285a.253.253,0,0,1,.111.209A.249.249,0,0,1,4,8.7l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.248.248,0,0,1,.256-.011.251.251,0,0,1,.131.22V10.5a.75.75,0,0,0,1.5,0v-.131a.25.25,0,0,1,.389-.207l.109.072a.75.75,0,0,0,.832-1.248l-.406-.271a.249.249,0,0,1,0-.417l.409-.268A.749.749,0,0,0,7.972,6.992Z', 'M14.627,6.992a.75.75,0,0,0-1.038-.216l-.125.082a.248.248,0,0,1-.256.011.252.252,0,0,1-.131-.22V6.5a.75.75,0,1,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,1,0-.832,1.248l.407.271a.25.25,0,0,1,0,.417l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.25.25,0,0,1,.387.209V10.5a.75.75,0,0,0,1.5,0v-.131a.25.25,0,0,1,.389-.207l.109.072a.75.75,0,0,0,.832-1.248L14,8.715A.25.25,0,0,1,14,8.3l.408-.268A.749.749,0,0,0,14.627,6.992Z', 'M17.75,11.5A6.25,6.25,0,1,0,24,17.75,6.257,6.257,0,0,0,17.75,11.5Zm3.162,5.028L18.128,20.24a1.46,1.46,0,0,1-1.071.584c-.036,0-.07,0-.1,0a1.463,1.463,0,0,1-1.039-.432l-1.437-1.438a.75.75,0,1,1,1.06-1.06l1.029,1.028a.5.5,0,0,0,.756-.056l2.392-3.242a.75.75,0,0,1,1.2.9Z']],
  PasswordCursor: ['password-cursor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.571,16.987a.5.5,0,0,0,.1-.932L15.224,12.33a.5.5,0,0,0-.671.671l3.725,7.449a.5.5,0,0,0,.932-.1l.6-2.4a.5.5,0,0,1,.364-.364Z', 'M13.586,11.363A1.986,1.986,0,0,1,15,10.777h0a2.009,2.009,0,0,1,.894.211l6.1,3.049a.5.5,0,0,0,.462-.008A1.991,1.991,0,0,0,23.5,12.277v-7a2,2,0,0,0-2-2H2.5a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H13.109a.25.25,0,0,0,.213-.118.248.248,0,0,0,.011-.243l-.122-.245A2,2,0,0,1,13.586,11.363ZM19,7.277a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,19,7.277Zm-14,3a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,5,10.277Zm5.5-1.5a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,10.5,8.777Z']],
  PasswordCursor1: ['password-cursor-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12.777a3,3,0,0,0,3,3h8.5a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1v7a1,1,0,1,0,2,0v-7a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3Z', 'M3.999 9.277 A1.500 1.500 0 1 0 6.999 9.277 A1.500 1.500 0 1 0 3.999 9.277 Z', 'M10.500 9.277 A1.500 1.500 0 1 0 13.500 9.277 A1.500 1.500 0 1 0 10.500 9.277 Z', 'M17.001 9.277 A1.500 1.500 0 1 0 20.001 9.277 A1.500 1.500 0 1 0 17.001 9.277 Z', 'M15.223,12.83a.5.5,0,0,0-.67.671l3.724,7.449a.5.5,0,0,0,.932-.1l.6-2.4a.5.5,0,0,1,.364-.364l2.4-.6a.5.5,0,0,0,.1-.932Z']],
  PasswordDesktopLock: ['password-desktop-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M22.5,4.4h-.25V3a2.75,2.75,0,0,0-5.5,0V4.4H16.5a1,1,0,0,0-1,1V9.9a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5.4A1,1,0,0,0,22.5,4.4Zm-3,3.75a1,1,0,1,1,1-1A1,1,0,0,1,19.5,8.15ZM18.25,4.4V3a1.25,1.25,0,0,1,2.5,0V4.4Z', 'M23,12.5a1,1,0,0,0-1,1v1a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H14a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V17.045A2.571,2.571,0,0,0,2.54,19.5H21.46A2.571,2.571,0,0,0,24,17.045V13.5A1,1,0,0,0,23,12.5Z', 'M14.062,5.525a.75.75,0,0,0-.75-.75h-8a1.753,1.753,0,0,0-1.75,1.75v3.5a1.753,1.753,0,0,0,1.75,1.75h8a.75.75,0,0,0,0-1.5h-8a.251.251,0,0,1-.25-.25v-3.5a.251.251,0,0,1,.25-.25h8A.75.75,0,0,0,14.062,5.525Z', 'M6.563 8.275 A1.000 1.000 0 1 0 8.563 8.275 A1.000 1.000 0 1 0 6.563 8.275 Z', 'M10.063 8.275 A1.000 1.000 0 1 0 12.063 8.275 A1.000 1.000 0 1 0 10.063 8.275 Z']],
  PasswordDesktop: ['password-desktop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M18,5H6A1.752,1.752,0,0,0,4.25,6.75v3.5A1.752,1.752,0,0,0,6,12H18a1.752,1.752,0,0,0,1.75-1.75V6.75A1.752,1.752,0,0,0,18,5Zm.25,5.25a.25.25,0,0,1-.25.25H6a.25.25,0,0,1-.25-.25V6.75A.25.25,0,0,1,6,6.5H18a.25.25,0,0,1,.25.25Z', 'M7.500 8.500 A1.000 1.000 0 1 0 9.500 8.500 A1.000 1.000 0 1 0 7.500 8.500 Z', 'M11.500 8.500 A1.000 1.000 0 1 0 13.500 8.500 A1.000 1.000 0 1 0 11.500 8.500 Z']],
  PasswordKey: ['password-key', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.5a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V7.5A.5.5,0,0,1,2.5,7h19a.5.5,0,0,1,.5.5V9a1,1,0,0,0,2,0V3A3,3,0,0,0,21,0ZM11,3.5a1,1,0,1,1-1-1A1,1,0,0,1,11,3.5Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,8,3.5Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,5,3.5Z', 'M11.942,9.913a1,1,0,0,0-1.414.03L7.118,13.5a.25.25,0,0,1-.181.077.246.246,0,0,1-.18-.077l-.535-.558a1,1,0,0,0-1.444,1.384l1.438,1.5a1,1,0,0,0,1.443,0l4.313-4.5A1,1,0,0,0,11.942,9.913Z', 'M17.382,16.118a.25.25,0,0,1-.25.063A3.853,3.853,0,0,0,16,16a4,4,0,1,0,4,4,3.841,3.841,0,0,0-.181-1.131.249.249,0,0,1,.063-.25l4.045-4.046A.248.248,0,0,0,24,14.4V12.25a.25.25,0,0,0-.25-.25H21.6a.249.249,0,0,0-.177.073ZM16,21.5A1.5,1.5,0,1,1,17.5,20,1.5,1.5,0,0,1,16,21.5Z']],
  TouchPasswordApproved1: ['touch-password-approved-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2v9a2,2,0,0,0,2,2H3a1,1,0,0,0,0-2H2.5a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5v8a.5.5,0,0,1-.5.5H13a1,1,0,0,0,0,2h9a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Z', 'M16,9.5h.033a1,1,0,0,0,.72-.341l3.5-4a1,1,0,0,0-1.506-1.317l-2.8,3.2L14.707,5.794a1,1,0,1,0-1.414,1.414l2,2A1,1,0,0,0,16,9.5Z', 'M13.389,17H10.5V10.5a2.5,2.5,0,1,0-5,0v8.835L4.411,17.808a2.136,2.136,0,0,0-2.8-.87,2.1,2.1,0,0,0-.87,2.8l2.1,3.993A.5.5,0,0,0,3.282,24H17.5a.5.5,0,0,0,.5-.5V21.848A4.8,4.8,0,0,0,13.389,17Z']],
  PasswordLock1: ['password-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.956,15.417h8.609a1,1,0,0,0,0-2H2.5a.5.5,0,0,1-.5-.5l-.038-6a.5.5,0,0,1,.5-.5H21.5a.5.5,0,0,1,.5.5v3.5a1,1,0,1,0,2,0v-4a1.981,1.981,0,0,0-1.956-2H1.956A1.981,1.981,0,0,0,0,6.417v7A1.981,1.981,0,0,0,1.956,15.417Z', 'M7.972,8.409a.75.75,0,0,0-1.038-.216l-.125.082a.25.25,0,0,1-.387-.209V7.917a.75.75,0,0,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,1,0-.832,1.248L4,9.7a.25.25,0,0,1,0,.417l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.248.248,0,0,1,.256-.011.251.251,0,0,1,.131.22v.148a.75.75,0,0,0,1.5,0v-.131a.25.25,0,0,1,.389-.208l.109.073A.75.75,0,0,0,7.752,10.4l-.406-.271a.249.249,0,0,1,0-.417l.409-.268A.749.749,0,0,0,7.972,8.409Z', 'M12.327,12.667a.75.75,0,0,0,.75-.75v-.131a.25.25,0,0,1,.389-.208l.109.073a.75.75,0,0,0,.832-1.248L14,10.132a.25.25,0,0,1,0-.417l.408-.268a.75.75,0,1,0-.822-1.254l-.125.082a.25.25,0,0,1-.387-.209V7.917a.75.75,0,0,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,1,0-.832,1.248l.407.271a.25.25,0,0,1,0,.417l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.25.25,0,0,1,.387.209v.148A.75.75,0,0,0,12.327,12.667Z', 'M22.664,15.515a.249.249,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,13.95,17v5.5a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5V17A1.5,1.5,0,0,0,22.664,15.515ZM19.95,20.25a1,1,0,1,1-1-1A1,1,0,0,1,19.95,20.25Zm-2.5-6a1.5,1.5,0,0,1,3,0v1a.25.25,0,0,1-.25.25H17.7a.25.25,0,0,1-.25-.25Z']],
  PasswordType: ['password-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,2.5H2.5A2.5,2.5,0,0,0,0,5V19a2.5,2.5,0,0,0,2.5,2.5h19A2.5,2.5,0,0,0,24,19V5A2.5,2.5,0,0,0,21.5,2.5ZM21,14.75H17a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,0,1.5Zm-6.469-1.28a.749.749,0,0,1,0,1.06.768.768,0,0,1-1.061,0l-1.293-1.293a.25.25,0,0,0-.353,0L10.531,14.53a.757.757,0,0,1-1.061,0,.749.749,0,0,1,0-1.06l1.293-1.293a.25.25,0,0,0,0-.354L9.47,10.53a.75.75,0,0,1,1.061-1.06l1.293,1.293a.25.25,0,0,0,.353,0L13.47,9.47a.75.75,0,0,1,1.061,1.06l-1.293,1.293a.25.25,0,0,0,0,.354Zm-7,0a.749.749,0,0,1,0,1.06.759.759,0,0,1-1.06,0L5.177,13.237a.252.252,0,0,0-.354,0L3.53,14.53a.768.768,0,0,1-1.06,0,.749.749,0,0,1,0-1.06l1.293-1.293a.252.252,0,0,0,0-.354L2.47,10.53A.75.75,0,0,1,3.53,9.47l1.293,1.293a.252.252,0,0,0,.354,0L6.47,9.47a.75.75,0,0,1,1.06,1.06L6.237,11.823a.252.252,0,0,0,0,.354Z']],
  TouchPasswordApproved: ['touch-password-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2v8.5a2,2,0,0,0,2,2H3a1,1,0,0,0,0-2H2.5A.5.5,0,0,1,2,10V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5V10a.5.5,0,0,1-.5.5h-9a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Z', 'M16,9.495a.993.993,0,0,0,.752-.337l3.5-4a1,1,0,1,0-1.5-1.316l-2.8,3.2L14.707,5.793a1,1,0,0,0-1.414,1.414l2,2A.991.991,0,0,0,16,9.495Z', 'M14.574,14.779,9.495,12.956V7.5a2,2,0,0,0-4,0v8.461l-.827-1.138a1.546,1.546,0,0,0-1.2-.558l-.99.019a1.476,1.476,0,0,0-1.3,2.179l3.735,6.773A1.463,1.463,0,0,0,6.2,24h6.386a1.478,1.478,0,0,0,1.379-.989l1.52-6.68a.511.511,0,0,0,.013-.111A1.435,1.435,0,0,0,14.574,14.779Z']],
  TouchPasswordLock: ['touch-password-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.329,14.779,13.25,12.956V7.5a2,2,0,0,0-4,0v8.461l-.827-1.139a1.55,1.55,0,0,0-1.2-.557l-.991.019a1.475,1.475,0,0,0-1.3,2.179L8.67,23.236A1.462,1.462,0,0,0,9.952,24h6.387a1.478,1.478,0,0,0,1.379-.989l1.519-6.68a.456.456,0,0,0,.013-.111A1.435,1.435,0,0,0,18.329,14.779Z', 'M6.25,11.546a1,1,0,0,0-1-1l-2.51-.038a.5.5,0,0,1-.493-.5L2.209,2.5a.5.5,0,0,1,.5-.5H13.25a1,1,0,0,0,0-2H2.206A2.005,2.005,0,0,0,.25,2.046V10.5a2.005,2.005,0,0,0,1.956,2.046H5.25A1,1,0,0,0,6.25,11.546Z', 'M22.75,4.9H22.5V3.5a2.75,2.75,0,0,0-5.5,0V4.9h-.25a1,1,0,0,0-1,1v4.5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5.9A1,1,0,0,0,22.75,4.9Zm-3,3.75a1,1,0,1,1,1-1A1,1,0,0,1,19.75,8.65ZM18.5,4.9V3.5a1.25,1.25,0,0,1,2.5,0V4.9Z']],
  PasswordDenied: ['password-denied', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.75,11.5A6.25,6.25,0,1,0,24,17.75,6.257,6.257,0,0,0,17.75,11.5Zm2.563,7.752a.75.75,0,0,1-1.06,1.061l-1.326-1.326a.249.249,0,0,0-.353,0l-1.326,1.326a.75.75,0,1,1-1.06-1.061l1.325-1.326a.249.249,0,0,0,0-.353l-1.325-1.326a.75.75,0,1,1,1.06-1.06l1.326,1.325a.249.249,0,0,0,.353,0l1.326-1.325a.75.75,0,1,1,1.06,1.06l-1.325,1.326a.249.249,0,0,0,0,.353Z', 'M0,4.5v7a1.981,1.981,0,0,0,1.957,2H9.815a1,1,0,0,0,0-2H2.5A.5.5,0,0,1,2,11L1.96,5a.5.5,0,0,1,.5-.5H21.5A.5.5,0,0,1,22,5V8.5a1,1,0,0,0,2,0v-4a1.981,1.981,0,0,0-1.956-2H1.957A1.981,1.981,0,0,0,0,4.5Z', 'M5.000 7.999 A1.500 1.500 0 1 0 8.000 7.999 A1.500 1.500 0 1 0 5.000 7.999 Z', 'M11.000 7.999 A1.500 1.500 0 1 0 14.000 7.999 A1.500 1.500 0 1 0 11.000 7.999 Z']],
  PasswordDenied1: ['password-denied-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.956,14h8.609a.87.87,0,0,0,.336-.07.5.5,0,0,0,.235-.2c.111-.182.23-.358.355-.529a.424.424,0,0,0,.064-.134.239.239,0,0,0,.01-.066,1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5l-.038-6a.5.5,0,0,1,.5-.5H21.5a.5.5,0,0,1,.5.5v4a1,1,0,0,0,2,0V5a1.981,1.981,0,0,0-1.956-2H1.956A1.981,1.981,0,0,0,0,5v7A1.981,1.981,0,0,0,1.956,14Z', 'M7.972,6.992a.75.75,0,0,0-1.038-.216l-.125.082a.25.25,0,0,1-.387-.209V6.5a.75.75,0,0,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,0,0-.832,1.248L4,8.285a.253.253,0,0,1,.111.209A.249.249,0,0,1,4,8.7l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.248.248,0,0,1,.256-.011.251.251,0,0,1,.131.22V10.5a.75.75,0,0,0,1.5,0v-.131a.25.25,0,0,1,.389-.207l.109.072a.75.75,0,0,0,.832-1.248l-.406-.271a.249.249,0,0,1,0-.417l.409-.268A.749.749,0,0,0,7.972,6.992Z', 'M14.627,6.992a.75.75,0,0,0-1.038-.216l-.125.082a.248.248,0,0,1-.256.011.252.252,0,0,1-.131-.22V6.5a.75.75,0,1,0-1.5,0v.131a.25.25,0,0,1-.389.208l-.109-.073a.75.75,0,1,0-.832,1.248l.407.271a.25.25,0,0,1,0,.417l-.408.268a.75.75,0,1,0,.822,1.254l.124-.081a.25.25,0,0,1,.387.209V10.5a.75.75,0,0,0,1.5,0v-.131a.25.25,0,0,1,.389-.207l.109.072a.75.75,0,0,0,.832-1.248L14,8.715A.25.25,0,0,1,14,8.3l.408-.268A.749.749,0,0,0,14.627,6.992Z', 'M17.75,11.5A6.25,6.25,0,1,0,24,17.75,6.257,6.257,0,0,0,17.75,11.5Zm2.562,7.752a.75.75,0,0,1-1.06,1.061l-1.325-1.326a.252.252,0,0,0-.354,0l-1.325,1.326a.75.75,0,1,1-1.06-1.061l1.325-1.325a.252.252,0,0,0,0-.354l-1.325-1.325a.75.75,0,1,1,1.06-1.06l1.325,1.325a.252.252,0,0,0,.354,0l1.325-1.325a.75.75,0,1,1,1.06,1.06l-1.325,1.325a.252.252,0,0,0,0,.354Z']],
  PasswordLock: ['password-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.125,12.625h9V7.267A1.619,1.619,0,0,0,11.5,5.656h-.375V4.581a4.5,4.5,0,0,0-9,0V5.656H1.75A1.619,1.619,0,0,0,.125,7.267v7.248a1.616,1.616,0,0,0,1.5,1.605v-1A2.5,2.5,0,0,1,4.125,12.625Zm0-8.044a2.5,2.5,0,0,1,5,0V5.656h-5Z', 'M22.125,14.375h-17a1.752,1.752,0,0,0-1.75,1.75v6a1.752,1.752,0,0,0,1.75,1.75h17a1.752,1.752,0,0,0,1.75-1.75v-6A1.752,1.752,0,0,0,22.125,14.375Zm-17.25,7.75v-6a.25.25,0,0,1,.25-.25h17a.25.25,0,0,1,.25.25v6a.25.25,0,0,1-.25.25h-17A.25.25,0,0,1,4.875,22.125Z', 'M9.436,19.125l.969-.97a.75.75,0,0,0-1.06-1.06l-.97.97-.97-.97a.75.75,0,0,0-1.06,1.06l.969.97-.969.97a.75.75,0,0,0,1.06,1.06l.97-.969.97.969a.75.75,0,1,0,1.06-1.06Z', 'M11.845,18.155l.969.97-.969.97a.749.749,0,0,0,0,1.06.76.76,0,0,0,1.06,0l.97-.969.97.969a.759.759,0,0,0,1.06,0,.749.749,0,0,0,0-1.06l-.969-.97.969-.97a.75.75,0,0,0-1.06-1.06l-.97.97-.97-.97a.75.75,0,0,0-1.06,1.06Z', 'M20,19.875H17.875a.75.75,0,0,0,0,1.5H20a.75.75,0,0,0,0-1.5Z']],
  PasswordLock2: ['password-lock-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,6.5v7a1.981,1.981,0,0,0,1.957,2h8.608a1,1,0,0,0,0-2H2.5A.5.5,0,0,1,2,13L1.96,7a.5.5,0,0,1,.5-.5H21.5A.5.5,0,0,1,22,7v3.5a1,1,0,0,0,2,0v-4a1.981,1.981,0,0,0-1.956-2H1.957A1.982,1.982,0,0,0,0,6.5Z', 'M5.000 10.000 A1.500 1.500 0 1 0 8.000 10.000 A1.500 1.500 0 1 0 5.000 10.000 Z', 'M11.000 10.000 A1.500 1.500 0 1 0 14.000 10.000 A1.500 1.500 0 1 0 11.000 10.000 Z', 'M21.882,15.515a.249.249,0,0,1-.214-.247V14.25a3.5,3.5,0,0,0-7,0v1.018a.249.249,0,0,1-.214.247A1.5,1.5,0,0,0,13.168,17v5.5a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5V17A1.5,1.5,0,0,0,21.882,15.515ZM18.168,21.25a1,1,0,1,1,1-1A1,1,0,0,1,18.168,21.25Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,0,1,3,0Z']],
  PasswordDesktopApproved: ['password-desktop-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M12,3.25A5.25,5.25,0,1,0,17.25,8.5,5.251,5.251,0,0,0,12,3.25Zm2.605,4.392-2.178,2.905a1.336,1.336,0,0,1-1.981.138L9.322,9.561A.75.75,0,0,1,10.383,8.5l.973.974,2.049-2.733a.75.75,0,1,1,1.2.9Z']],
  TouchPasswordLock1: ['touch-password-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.25,12.3a1,1,0,0,0-1-1l-2.51-.038a.5.5,0,0,1-.493-.5L2.209,3.253a.5.5,0,0,1,.5-.5H13.25a1,1,0,1,0,0-2H2.206A2,2,0,0,0,.25,2.8v8.455A2,2,0,0,0,2.206,13.3H5.25A1,1,0,0,0,6.25,12.3Z', 'M16.139,16.251H13.25v-6.5a2.5,2.5,0,0,0-5,0v8.835L7.161,17.058A2.075,2.075,0,1,0,3.489,18.99l2.1,3.993a.5.5,0,0,0,.442.267H20.25a.5.5,0,0,0,.5-.5V21.1A4.8,4.8,0,0,0,16.139,16.251Z', 'M22.75,5.651H22.5v-1.4a2.75,2.75,0,0,0-5.5,0v1.4h-.25a1,1,0,0,0-1,1v4.5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-4.5A1,1,0,0,0,22.75,5.651Zm-3,3.75a1,1,0,1,1,1-1A1,1,0,0,1,19.75,9.4ZM18.5,5.651v-1.4a1.25,1.25,0,0,1,2.5,0v1.4Z']],
  PasswordApproved: ['password-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.000 6.750 A1.500 1.500 0 1 0 8.000 6.750 A1.500 1.500 0 1 0 5.000 6.750 Z', 'M17.75,10.25A6.25,6.25,0,1,0,24,16.5,6.257,6.257,0,0,0,17.75,10.25Zm3.163,5.028L18.13,18.99a1.46,1.46,0,0,1-1.076.583c-.035,0-.072,0-.107,0a1.454,1.454,0,0,1-1.035-.434l-1.435-1.436a.75.75,0,0,1,1.06-1.06l1.234,1.234a.251.251,0,0,0,.2.072.247.247,0,0,0,.182-.1l2.563-3.475a.751.751,0,1,1,1.2.9Z', 'M0,3.25v7a1.981,1.981,0,0,0,1.957,2H9.815a1,1,0,0,0,0-2H2.5a.5.5,0,0,1-.5-.5l-.037-6a.5.5,0,0,1,.5-.5H21.5a.5.5,0,0,1,.5.5v3.5a1,1,0,0,0,2,0v-4a1.981,1.981,0,0,0-1.956-2H1.957A1.982,1.982,0,0,0,0,3.25Z', 'M11.000 6.750 A1.500 1.500 0 1 0 14.000 6.750 A1.500 1.500 0 1 0 11.000 6.750 Z']],
  PasswordDesktopLockApproved: ['password-desktop-lock-approved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M22.5,4.4h-.25V3a2.75,2.75,0,0,0-5.5,0V4.4H16.5a1,1,0,0,0-1,1V9.9a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V5.4A1,1,0,0,0,22.5,4.4Zm-3,3.75a1,1,0,1,1,1-1A1,1,0,0,1,19.5,8.15ZM18.25,4.4V3a1.25,1.25,0,0,1,2.5,0V4.4Z', 'M4,8.5A4.5,4.5,0,1,0,8.5,4,4.5,4.5,0,0,0,4,8.5Zm6.956-1.909a.751.751,0,0,1,.149,1.051L8.927,10.547a1.306,1.306,0,0,1-.959.521c-.031,0-.062,0-.093,0a1.309,1.309,0,0,1-.929-.387L5.822,9.561A.75.75,0,0,1,6.883,8.5l.973.974L9.9,6.741A.753.753,0,0,1,10.956,6.591Z', 'M23,13a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H14a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V17.045A2.571,2.571,0,0,0,2.54,19.5H21.46A2.571,2.571,0,0,0,24,17.045V14A1,1,0,0,0,23,13Z']]
};
exports["default"] = _default;